var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.655 9.625V10.5931C21.655 11.755 21.9867 12.8909 22.608 13.8575L24.1307 16.2266C25.5217 18.3905 24.4599 21.3316 22.0407 22.0159C15.7125 23.8059 9.03752 23.8059 2.70925 22.0159C0.290194 21.3316 -0.771622 18.3905 0.619246 16.2266L2.14198 13.8575C2.76337 12.8909 3.09495 11.755 3.09495 10.5931V9.625C3.09495 4.30926 7.24977 0 12.375 0C17.5002 0 21.655 4.30926 21.655 9.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5312fdb32e83c5f9b903518984e4c242.svg";
export { ForwardRef as ReactComponent };